<template>
  <div class="bin-supply">
    <el-dialog
      width="640px"
      align="center"
      title="批量绑定「次品员与退供员」"
      :visible="visible"
      :before-close="closeBox"
    >
      <el-form :model="form">
        <el-row :gutter="24">
          <el-col :span="10">
            <el-form-item label="商家id（一行一个，最多1000个）" required>
              <!-- <div style="margin-bottom: 16px">
              <span></span>
            </div> -->
              <el-input
                v-model="form.supply_ids"
                :rows="8"
                type="textarea"
                placeholder="一行一个id"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="14" :style="{ marginTop: '40px' }">
            <el-form-item label="选择次品组" align="left" required>
              <el-select
                v-model="form.dgid"
                placeholder="请选择"
                filterable
                @change="getGroupMember"
              >
                <el-option
                  v-for="item in groupList"
                  :key="item.value"
                  :value="item.value"
                  :label="item.label"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="选择次品员" align="left" required>
              <el-select
                v-model="form.dg_member_id"
                placeholder="请选择"
                filterable
              >
                <el-option
                  v-for="item in member"
                  :key="item.value"
                  :value="item.value"
                  :label="item.label"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="选择退供员" align="left" required>
              <el-select
                v-model="form.refund_member_id"
                placeholder="请选择"
                filterable
              >
                <el-option
                  v-for="item in refundMember"
                  :key="item.value"
                  :value="item.value"
                  :label="item.label"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeBox(0)">取 消</el-button>
        <el-button size="small" type="success" @click="bind">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getOptionsForSupplyList,
} from "@/openapi/erp/supply.js";
import apiBaseURL from "@/utils/baseUrl.js";
export default {
  name: "DgBindSupply",
  props: {
    supplyIds: {
      type: Array,
      default: () => [],
    },
    group: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      visible: true,
      form: {
        supply_ids: "",
        dgid: "",
        dg_member_id: "",
        refund_member_id: ""
      },
      member: [],
      refundMember: [],
      groupList: []
    };
  },
  mounted() {
    this.fetchOptionsData()
  },
  methods: {
    closeBox(isNormal) {
      let _isNormal = isNormal;
      if (typeof isNormal === "function") {
        _isNormal = 0;
      }
      this.$emit("on-close-dialog", _isNormal);
    },
    fetchOptionsData() {
      this.$http
        .post("/erp/Supply/optionsForSupplyList", {})
        .then((res) => {
          console.log(res)
          if (res.data.code === 200) {
            this.groupList = res.data.data.defectiveGroupOption;
          }
        });
    },
    getGroupMember(id) {
      this.$http
        .post("/erp/defective/getGroupMember", {
          dgid: id,
        })
        .then((res) => {
          if (res.data.code === 200) {
            this.member = res.data.data.member;
            this.refundMember = res.data.data.refundMember;
            this.form.dg_member_id = "";
            this.form.refund_member_id = ""
          }
        });
    },
    bind() {
      const {
        dgid,
        dg_member_id: dgMemberId,
        supply_ids: supplyIds,
        refund_member_id
      } = this.form;

      // 校验是否有商家id
      if (supplyIds === "") {
        this.$message({
          showClose: true,
          message: "请输入商家ids~",
          type: "error",
        });
        return;
      }

      this.$http
        .post("/erp/Supply/SupplyBindDgGroupAndMember", {
          dgid,
          dg_member_id: dgMemberId,
          supply_ids: supplyIds.trim().split("\n"),
          refund_member_id
        },{
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          if (res.data.code === 200) {
            this.$message.success("绑定成功");
            this.closeBox(true);
          } else {
            this.$message.error(res.data.msg);
            if (res.data.data && res.data.data.file) {
              window.open(apiBaseURL + res.data.data.file);
            }
          }
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/DgBindSupply.vue